module.exports = __webpack_public_path__ + "static/img/huijiao14.c4c43aa2.png";